var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('zj-layout-container',[_c('zj-layout-main',[_c('div',{staticClass:"zj-layout-main-content bgcolor scrollable"},[_vm._v(" 权限管理 ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }